const marketingCookieName = 'fnv-cookie-level2';
const marketingLevel3CookieName = 'fnv-cookie-level3';

import fetch from 'cross-fetch';
import { CookieManager } from '@fnv-core/cookies';

declare global {
  interface Window {
    doNotTrack?: '0' | '1';
    dataLayer: Record<string, any>[];
  }
}

function showCookieMelding() {
  $(".cookiebanner").removeClass("cookiebanner--hide");
}

function hideCookieMelding() {
  $(".cookiebanner").addClass("cookiebanner--hide");
}

export interface IConsent {
  Name: string;
  Accept: boolean;
  IsMarketingConsent: boolean;
}

function sendConsents(consents: IConsent[]) {
  return fetch("/api/consent/set", {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(consents)
  });
}

function addDataLayerConsent(level2Consent: boolean = null, level3Consent: boolean = null) {
  if (level2Consent != null && level3Consent != null) {
    window.dataLayer.push({
      'event': 'cookie_consent_updated',
      'fnv-cookie-level1' : 'granted',
      'fnv-cookie-level2': consentToString(level2Consent),
      'fnv-cookie-level3': consentToString(level3Consent)
    });
  }
  else if (level2Consent == null && level3Consent != null) {
    window.dataLayer.push({
      'event': 'cookie_consent_updated',
      'fnv-cookie-level1': 'granted',
      'fnv-cookie-level3': consentToString(level3Consent)
    });
  }
  else if (level2Consent != null && level3Consent == null) {
    window.dataLayer.push({
      'event': 'cookie_consent_updated',
      'fnv-cookie-level1': 'granted',
      'fnv-cookie-level2': consentToString(level2Consent)
    });
  }

  function consentToString(consent: boolean) {
    return consent ? 'granted' : 'denied';
  }
}

export class CookieController {
  constructor() {
    $(document).ready(function () {
      const consentName = $(".cookiebanner__container").attr("data-consent-name");
      const consentLevel3Name = $(".cookiebanner__container").attr("data-consent-level3-name");
      window.dataLayer = window.dataLayer || [];

      let acceptConsent = marketingCookieName;
      if (consentName != "") {
        acceptConsent = consentName;
      }

      let acceptConsentLevel3 = marketingLevel3CookieName;
      if (consentLevel3Name != "") {
        acceptConsentLevel3 = consentLevel3Name;
      }

      if ($(".cookiebanner").length > 0) {

        const marketingCookie = CookieManager.readCookie(marketingCookieName);
        if (marketingCookie !== "" &&
          marketingCookie !== consentName + "opt-in" &&
          marketingCookie !== consentName + "opt-out") {
          CookieManager.deleteCookie("fnv-cookies-accepted");
          CookieManager.deleteCookie("marketingCookie");
        }

        const marketingLevel3Cookie = CookieManager.readCookie(marketingLevel3CookieName);
        if (marketingLevel3Cookie !== "" &&
          marketingLevel3Cookie !== consentLevel3Name + "opt-in" &&
          marketingLevel3Cookie !== consentLevel3Name + "opt-out") {
          CookieManager.deleteCookie("fnv-cookies-accepted");
          CookieManager.deleteCookie("marketingLevel3Cookie");
        }

        let fnvCookie = CookieManager.readCookie("fnv-cookies-accepted");
        if (!fnvCookie) {
          if (window.doNotTrack || navigator.doNotTrack || (<any> navigator).msDoNotTrack || (typeof window.external !== "undefined" && 'msTrackingProtectionEnabled' in window.external)) {

            // The browser supports Do Not Track!      
            if (window.doNotTrack == "1" || navigator.doNotTrack == "yes" || navigator.doNotTrack == "1" ||
              (<any> navigator).msDoNotTrack == "1" ||
              (typeof window.external !== "undefined" &&
                ('msTrackingProtectionEnabled' in window.external) &&
                (<any> window.external).msTrackingProtectionEnabled()
              )) {
              // Do Not Track (DNT()) is enabled!

              CookieManager.createCookie("fnv-cookies-accepted", "1", 360);
              CookieManager.createCookie(marketingCookie, consentName + "opt-out", 360);
              CookieManager.createCookie(marketingLevel3CookieName, consentLevel3Name + "opt-out", 360);
              hideCookieMelding();

              sendConsents([
                { Name: acceptConsent, Accept: false, IsMarketingConsent: true },
                { Name: acceptConsentLevel3, Accept: false, IsMarketingConsent: false }
              ]).then(() => {
                CookieManager.createCookie("fnv-cookies-accepted", "1", 360);
                CookieManager.createCookie(marketingCookie, consentName + "opt-out", 360);
                CookieManager.createCookie(marketingLevel3CookieName, consentLevel3Name + "opt-out", 360);
              });
              return;
            }
          }
        }

        showCookieMelding();

        if (fnvCookie) {
          hideCookieMelding();
        } else {
          showCookieMelding();
        }
      }

      const marketingCookieConsent: string = CookieManager.readCookie(marketingCookieName);

      if (marketingCookieConsent == consentName + "opt-in") {

        if ($("#cookiebanner-marketing").length > 0) {
          $("#cookiebanner-marketing").prop("checked", true);
        }

        if ($("#cookiebanner-marketing-setting").length > 0) {
          $("#cookiebanner-marketing-setting").prop("checked", true);
        }
      }

      const marketingLevel3CookieConsent: string = CookieManager.readCookie(marketingLevel3CookieName);

      if (marketingLevel3CookieConsent == consentLevel3Name + "opt-in") {

        if ($("#cookiebanner-marketing-level3").length > 0) {
          $("#cookiebanner-marketing-level3").prop("checked", true);
        }

        if ($("#cookiebanner-marketing-setting-level3").length > 0) {
          $("#cookiebanner-marketing-setting-level3").prop("checked", true);
        }
      }

      $(document).on("click", ".cookiebanner__accept-all-cookiemessage", function (e) {

        const onCookieSettingsPage = $(this).hasClass("cookiebanner__via-settings");

        if (!onCookieSettingsPage && $(".cookiebanner__moreinfo.collapsed").length > 0) {

          sendConsents([
            { Name: acceptConsent, Accept: true, IsMarketingConsent: true },
            { Name: acceptConsentLevel3, Accept: true, IsMarketingConsent: false }
          ]);

          CookieManager.createCookie("fnv-cookies-accepted", "1", 360);
          CookieManager.createCookie(marketingCookieName, consentName + "opt-in", 360);
          CookieManager.createCookie(marketingLevel3CookieName, consentLevel3Name + "opt-in", 360);
          addDataLayerConsent(true, true);
          hideCookieMelding();

          $('html, body').animate({
            scrollTop: '0px'
          });

        } else {
          CookieManager.createCookie("fnv-cookies-accepted", "1", 360);

          if (onCookieSettingsPage && $("#cookiebanner-marketing-setting").length > 0) {

            if ($("#cookiebanner-marketing-setting:checked").val() == "on") {
              sendConsents([
                { Name: acceptConsent, Accept: true, IsMarketingConsent: true }
              ]);
              CookieManager.createCookie(marketingCookieName, consentName + "opt-in", 360);
              addDataLayerConsent(true, null);
            } else {
              sendConsents([
                { Name: acceptConsent, Accept: false, IsMarketingConsent: true }
              ]);
              CookieManager.createCookie(marketingCookieName, consentName + "opt-out", 360);
              addDataLayerConsent(false, null);
            }
            if ($("#cookiebanner-marketing-setting-level3:checked").val() == "on") {
              sendConsents([
                { Name: acceptConsentLevel3, Accept: true, IsMarketingConsent: false }
              ]);
              CookieManager.createCookie(marketingLevel3CookieName, consentLevel3Name + "opt-in", 360);
              addDataLayerConsent(null, true);
            } else {
              sendConsents([
                { Name: acceptConsentLevel3, Accept: false, IsMarketingConsent: false }
              ]);
              CookieManager.createCookie(marketingLevel3CookieName, consentLevel3Name + "opt-out", 360);
              addDataLayerConsent(null, false);
            }
          } else {

            if ($("#cookiebanner-marketing:checked").val() == "on") {
              sendConsents([
                { Name: acceptConsent, Accept: true, IsMarketingConsent: true }
              ]);
              CookieManager.createCookie(marketingCookieName, consentName + "opt-in", 360);
              addDataLayerConsent(true, null);
            } else {
              sendConsents([
                { Name: acceptConsent, Accept: false, IsMarketingConsent: true }
              ]);
              CookieManager.createCookie(marketingCookieName, consentName + "opt-out", 360);
              addDataLayerConsent(false, null);
            }
            if ($("#cookiebanner-marketing-level3:checked").val() == "on") {
              sendConsents([
                { Name: acceptConsentLevel3, Accept: true, IsMarketingConsent: false }
              ]);
              CookieManager.createCookie(marketingLevel3CookieName, consentLevel3Name + "opt-in", 360);
              addDataLayerConsent(null, true);
            } else {
              sendConsents([
                { Name: acceptConsentLevel3, Accept: false, IsMarketingConsent: false }
              ]);
              CookieManager.createCookie(marketingLevel3CookieName, consentLevel3Name + "opt-out", 360);
              addDataLayerConsent(null, false);
            }
          }
          hideCookieMelding();

          if (!onCookieSettingsPage) {
            $('html, body').animate({
              scrollTop: '0px'
            });
          }
        }
        e.preventDefault();
        return false;
      });

      $('.collapse.cookiebanner__controls').on('hidden.bs.collapse', function () {
        const text = $(".cookiebanner__accept-all-cookiemessage").attr("data-text-all-cookies");
        $(".cookiebanner__accept-cookiemessage-button-text").text(text);
      });

      $('.collapse.cookiebanner__controls').on('shown.bs.collapse', function () {
        const text = $(".cookiebanner__accept-all-cookiemessage").attr("data-text-cookies");
        $(".cookiebanner__accept-cookiemessage-button-text").text(text);
      });

      $(".cookiebanner__close").click(function (event) {
        event.preventDefault();
        CookieManager.createCookie("fnv-cookies-accepted", "1", 360);
        hideCookieMelding();
        return false;
      });
    });
  }
}
